import React from 'react';
import { Box } from '@chakra-ui/react';

const BubbleTail = ({ bgColour, direction = `left`, ...props }) => {
  const left = {
    borderWidth: `8px 8px 0 0`,
    borderColor: `transparent ${bgColour} transparent transparent`
  };

  const right = {
    borderWidth: `8px 0 0 8px`,
    borderColor: `transparent transparent transparent  ${bgColour}`
  };

  const useStyle = direction === `left` ? left : right;

  return (
    <Box
      pos="absolute"
      left="-8px"
      bottom="8px"
      as="span"
      w="0"
      h="0"
      borderStyle="solid"
      {...useStyle}
      {...props}
    />
  );
};

export default BubbleTail;
